import { isArray } from 'lodash';
import { formatIdentifier } from '../../../../react-commons/utils/utilFunctions';
import { ResourceType } from '../../resource/enumerations/ResourceType';
import { getPropertyLabelInfo } from '../util/utilFunctions';
import { useSystemInformationActions } from '../../resource/services/systemInformationService';

export const usePropertyInfo = ({
        propertyIdentifier,
        resourceType,
        resourceId,
        hideLabel,
        labelOverride,
        readOnly,
    }: {
        propertyIdentifier: string | string[],
        resourceType: ResourceType,
        resourceId: string | null | undefined,
        hideLabel: boolean | undefined,
        labelOverride: string | undefined,
        readOnly: boolean | undefined,
    }
) => {
    const systemInformationActions = useSystemInformationActions();
    const propertyDetails = systemInformationActions.useGetPropertyDetails(propertyIdentifier, resourceType);
    const propertyValidation = systemInformationActions.useGetPropertyValidationWithId(propertyIdentifier, resourceType, resourceId);

    const label = hideLabel
        ? undefined
        : labelOverride
            ? labelOverride
            : isArray(propertyDetails)
                ? propertyDetails[0]?.displayName
                    ? propertyDetails[0]?.displayName
                    : formatIdentifier(propertyDetails[0]?.propertyName ?? '')
                : propertyDetails?.displayName
                    ? propertyDetails.displayName
                    : formatIdentifier(propertyDetails?.propertyName ?? '');
    const isReadOnly =
        readOnly !== undefined
            ? readOnly
            : isArray(propertyDetails) && propertyDetails[0]?.updatable !== undefined
                ? !propertyDetails[0].updatable
                : !isArray(propertyDetails) && propertyDetails?.updatable !== undefined
                    ? !propertyDetails.updatable
                    : false;
    const labelInfo = hideLabel ? undefined : getPropertyLabelInfo(propertyDetails);

    return {
        label,
        labelInfo,
        readOnly: isReadOnly,
        severity: propertyValidation?.severity,
        helperText: propertyValidation?.identifier,
    };
};
